import { useState, useEffect, useContext } from 'react';
import { WizardContext } from '../WizardContext';
import listService from "ListService";
import { processControlModel } from '../../utils/mobileUtils';


export const useDesktopControls = () => {
    const { activePage, layout } = useContext(WizardContext);

    const [controls, setControls] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        if (!activePage) return;

        const currentPageId = activePage.id;

        setIsLoading(true);
        const placedControlIds = new Set(
            (layout[currentPageId] || []).flatMap(section =>
                section.controls.map(c => c.id)
            )
        );

        const rawControls = listService.getPageControls(currentPageId);

        const topLevelControls = rawControls.filter(control => !control['_groupId']);
        const processedControls = topLevelControls.map(control => {
            const processed = processControlModel(control.model, 'desktop');
            processed.isPlaced = placedControlIds.has(processed.id);
            return processed;
        }).toArray();


        setControls(processedControls);
        setIsLoading(false);
    }, [activePage, layout]);

    const sendControlToBack = (controlId) => {
        setControls(currentControls => {
            if (currentControls.length < 2) return currentControls;

            // Find the lowest z-index in the current state
            const minZ = Math.min(...currentControls.map(c => c.zOrder));
            return currentControls.map(c =>
                c.id === controlId
                    ? { ...c, zOrder: minZ - 1 }
                    : c
            );
        });
    };

    return { controls, isLoading, sendControlToBack };
};